// Small, deterministic helpers for rendering club marks without per-club assets.

/** A short team code: the stored one, else the first three letters upper-cased. */
export function teamCode(name: string, code?: string): string {
  if (code) return code;
  return name.replace(/[^A-Za-z]/g, '').slice(0, 3).toUpperCase() || name.slice(0, 3).toUpperCase();
}

/** Deterministic, colourful gradient for a club mark derived from a seed string. */
export function teamGradient(seed: string): string {
  let h = 0;
  for (const ch of seed) h = (h * 31 + ch.charCodeAt(0)) % 360;
  const h2 = (h + 20) % 360;
  return `linear-gradient(140deg, hsl(${h} 58% 46%), hsl(${h2} 62% 26%))`;
}

/** A compact team name that won't wrap a row ("Tottenham Hotspur" → "Hotspur"). */
export function shortTeam(name: string): string {
  return name.length > 11 ? name.split(/\s+/).slice(-1)[0] : name;
}
